import {ModelBase} from "../model-base";
import {IModelBase} from "../i-model-base";
import {VATRate} from "../common/vat-rate";
import {BusinessCaseType} from "../common/business-case-type";

export class CompositionTypeNl extends ModelBase implements IModelBase {
  vatRate: VATRate = VATRate.NORMAL;
  businessCaseType: BusinessCaseType = BusinessCaseType.Umsatz;

  static default(): CompositionTypeNl {
    let undefinedComposition = new CompositionTypeNl()
    undefinedComposition.id = ""
    undefinedComposition.name = "Ohne Zuordnung"
    undefinedComposition.vatRate = VATRate.NORMAL
    undefinedComposition.businessCaseType = BusinessCaseType.Umsatz
    return undefinedComposition
  }

  static containsDefault(compositions: CompositionTypeNl[]): boolean {
    return compositions.some(composition => composition.id === "")
  }
}
